<template>
  <div class="container">
        <div class="wrap">
            <pageHeader/>
            <pageBack/>
            <div class="main">
                <p class="title">衣服尺寸数据</p>
                <div class="part">
                    <p class="font40">已选部件</p>
                    <ul>
                        <li v-for="(item,index) in list" :key="index">
                            <img :src="item.path" alt="" srcset="">
                            <p>{{item.title}}</p>
                        </li>
                    </ul>
                </div>
                <div class="cloth-data">
                    <!-- 左侧衣服尺寸 -->
                    <div class="cloth-size-img">
                        <img src="../../assets/yf.png" alt="" srcset="">
                    </div>
                    <div class="size-datas">
                        <div class="size-img">
                            <div class="front-img">
                                <img :src="img" alt="" srcset="" v-for="(img,i) in frontimgs" :key="i">
                            </div>
                            <div class="back-img">
                                <img :src="img" alt="" srcset="" v-for="(img,i) in backimgs" :key="i">
                            </div>
                        </div>
                        <div class="size-data">
                            <div v-for="(size,index) in aiinfo" :key="index">
                                <p>
                                    <span class="font72">{{size.value}}</span>
                                </p>
                                <p>
                                    <span class="font40">{{size.title}}</span>
                                </p>
                                <p class="font40">
                                    <span>{{size.desc}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="start-btn" @click="to_link()">
                    <img src="../../assets/index/btn_bg.png" alt="" srcset="">
                    <p>
                    <span>虚拟试衣</span>
                    </p>
                </div>
            </div>
        </div>
        <pagePop status='fitting' v-if="showLoad" @goBack="goBack()" />
    </div>
</template>
<script>
import pagePop from '../../components/popup.vue'
import { getInfo,getPartsImgs } from '@/api/user';
import { Toast } from 'vant';
export default {
    name:'clothSize',
    components: {
        pagePop
    },
    data() {
        return {
        list:[],
        aiinfo:[
            {
                title:'后衣长',
                value:'',
                desc:'(BCL)'
            },{
                title:'肩宽',
                value:'',
                desc:'(S)'
            },{
                title:'领围',
                value:'',
                desc:'(N)'
            },{
                title:'胸围',
                value:'',
                desc:'(B)'
            },{
                title:'袖长',
                value:'',
                desc:'(SL)'
            },{
                title:'袖口',
                value:'',
                desc:''
            },
        ],
        frontimgs:[
            // "https://bjyqtg.cn:9000/clothing/public/clothing-components/male/M22200089/M22200089-M5长袖.png",
            // "https://bjyqtg.cn:9000/clothing/public/clothing-components/male/M22200089/M22200089-M5圆摆.png",
            // "https://bjyqtg.cn:9000/clothing/public/clothing-components/male/M22200089/M22200089-M5圆角领领座.png"
        ],
        backimgs:[
            // "https://bjyqtg.cn:9000/clothing/public/clothing-components/male/M22200089/M22200089-M1长袖.png",
            // "https://bjyqtg.cn:9000/clothing/public/clothing-components/male/M22200089/M22200089-M1圆摆.png",
            // "https://bjyqtg.cn:9000/clothing/public/clothing-components/male/M22200089/M22200089-M1明门襟.png",
            // "https://bjyqtg.cn:9000/clothing/public/clothing-components/male/M22200089/M22200089-M1立领.png"
        ],
        id:localStorage.getItem('taskId'),//,// || 2645
        showLoad:false,
        timer:null
    }
  },
  methods: {
    to_link(){
        this.showLoad = true;
        // setTimeout(() => {
        //     this.$router.push({ name: 'videoLoad',params:{status:'fitting'} });  //跳转到试��页面
        // }, 4000);
        this.timer = setInterval(() => {
            this.getInfo()
        }, 2000);
        // setTimeout(() => {
        //     this.$router.push({ path: '/aiEffect'})
        // }, 4500);
    },
    goBack(){
        clearInterval(this.timer)
        this.$router.go(-1)
    },
    getInfo(){
        getInfo({id:localStorage.getItem('taskId')}).then((res) => {
            if (res.code === 1) {
                let status = res.data.status3d;
                if(status == 2){
                    localStorage.setItem('userInfo', JSON.stringify(res.data));
                    clearInterval(this.timer)
                    setTimeout(() => {
                        this.$router.push({ path: '/aiEffect'})
                    }, 2000);
                }else if(status == -1){
                    clearInterval(this.timer)
                    Toast('数据识别失败,请重试！');
                    setTimeout(() => {
                        this.$router.go(0);
                    }, 1000);
                }
            }
        });
    },
    getData(){
        // localStorage.setItem('taskId',34)
        getInfo({id:this.id}).then((res) => {
          if (res.code === 1) {
            let aiinfo = res.data.aiinfo;
            if(aiinfo){
                this.aiinfo[0].value = aiinfo.find(item => item.partName === "后衣长")?.rtw;
                this.aiinfo[1].value = aiinfo.find(item => item.partName === "肩宽")?.rtw;
                this.aiinfo[2].value = aiinfo.find(item => item.partName === "领围")?.rtw;
                this.aiinfo[3].value = aiinfo.find(item => item.partName === "胸围")?.rtw;
                this.aiinfo[4].value = aiinfo.find(item => item.partName === "袖长")?.rtw;
                this.aiinfo[5].value = aiinfo.find(item => item.partName === "袖口")?.rtw;
            }
          }else{
            Toast(res.msg)
          }
      });
    //   localStorage.getItem('taskId')
      getPartsImgs({id:this.id}).then((res) => {
        if (res.code === 1) {
          this.frontimgs = res.data.frontimgs;
          this.backimgs = res.data.backimgs;
        } else{
          Toast(res.msg)
        }
      })
    }
  },
  // 例如这个函数就会在组件挂载完成后被调用
  mounted() {
    this.list = JSON.parse(localStorage.getItem('custom_parts'))
    this.getData() 
  }
}
</script>
<style src="./index.less" scoped lang="less"></style>